import React, { useState, useMemo, useCallback } from 'react'

import { toast } from 'react-toastify'
import { twMerge } from 'tailwind-merge'

import { useMatchCensusPreSignup } from 'services/census'
import { getInputsByContract } from 'services/preSignUp'

import { Button } from 'components/v2/Button'
import { CardDefault } from 'components/v2/Cards'
import { Column, Row } from 'components/v2/Grid'
import { MaskedInput } from 'components/v2/Input'
import { Text } from 'components/v2/Text'
import Wrapper from 'components/Wrapper'

const KEYS = {
	presigup_text_input: 'external_key',
	email: 'email',
	cpf: 'cpf'
}

const key = (name) => KEYS[name?.toLocaleLowerCase()] ?? 'external_key'

const Parceria = ({ contractId, contractInputs, query }) => {
	const [values, setValues] = useState({})

	const { isLoading, mutate: preSignUp } = useMatchCensusPreSignup({
		onSuccess: (payload) => {
			toast.success('Matrícula verificada com sucesso')

			if (typeof window === 'undefined') return

			const presignup = payload?.data?.pre_signups?.[0]

			if (query?.census_id) {
				return window.parent.postMessage(
					{
						type: 'REDIRECT',
						target: `${window.location.origin}/coleta?company=${presignup?.integration?.contract?.company}&census_id=${query?.census_id}&presignup_id=${presignup?.id}`
					},
					'*'
				)
			}
		},
		onError: (exception) => {
			switch (exception?.response?.data?.error) {
				case 'Could not find any presignup':
					return toast.error(
						'Matrícula inválida. Verifique sua matrícula e tente novamente'
					)

				case 'Invalid Email':
					return toast.error('Matrícula inválida')

				default:
					return toast.error('Ocorreu um erro na verificação da matrícula')
			}
		}
	})

	const canSubmit = useMemo(
		() =>
			contractInputs?.inputs?.reduce(
				(submittable, input) =>
					submittable && input?.required ? !!values[key(input?.name)] : true,
				true
			),
		[contractInputs?.inputs, values]
	)

	console.log('values', values)
	const onSubmit = useCallback(
		(event) => {
			event.preventDefault()

			preSignUp({
				contract_ids: contractId,
				...values
			})
		},
		[contractId, values, preSignUp]
	)

	return (
		<Wrapper>
			<Column
				className={twMerge('h-screen w-full')}
				style={{
					background: query?.background ? `#${query.background}` : '#F8F8F8'
				}}
			>
				<Row className='mt-[100px] justify-center sm:mt-[138px]'>
					<CardDefault className='w-[302px] justify-center border border-solid border-[#E7EAF4] p-6'>
						<Column
							as='form'
							className='w-full items-center'
							onSubmit={onSubmit}
						>
							<Row className='mb-4 w-full justify-center'>
								<Row className='h-[15px] w-full border-b border-solid border-black/10' />
								<Text
									variant='regular'
									className='px-4 text-[22px] text-gray-800'
								>
									Olá!
								</Text>
								<Row className='h-[15px] w-full border-b border-solid border-black/10' />
							</Row>

							{
								<>
									{contractInputs?.inputs?.map((input) => (
										<MaskedInput
											key={key(input?.name)}
											variant='primary'
											className='mb-2.5 w-full rounded shadow-none'
											onChange={(e) =>
												setValues({
													...values,
													[key(input?.name)]: e.target.value
												})
											}
											mask='no_mask'
											value={values[key(input?.name)]}
											name={input?.label?.toLowerCase()}
											label={`${input?.label}*`}
											placeholder={query?.placeholder ?? 'Digite sua Matrícula'}
											labelProps={{
												color: query?.primary ? `#${query?.primary}` : 'primary'
											}}
										/>
									))}

									<Button
										type='submit'
										className='h-[50px] w-full'
										disabled={!canSubmit || isLoading}
										style={
											query?.primary ? { background: `#${query?.primary}` } : {}
										}
										loading={isLoading}
									>
										<Text variant='small' className='font-bold'>
											Entrar
										</Text>
									</Button>
								</>
							}
						</Column>
					</CardDefault>
				</Row>
			</Column>
		</Wrapper>
	)
}

export const getServerSideProps = async ({ params, query, res }) => {
	res.setHeader(
		'Cache-Control',
		'public, s-maxage=10, stale-while-revalidate=59'
	)

	const { id } = params

	const mapping = {
		object: query?.contract_id,
		string: [query?.contract_id],
		undefined: []
	}
	const contractId = [id, ...mapping[typeof query?.contract_id]]

	try {
		const {
			data: { data }
		} = await getInputsByContract(id)

		console.log('======= DATA =======', data)

		return {
			props: {
				contractId,
				contractInputs: data,
				query
			}
		}
	} catch (exception) {
		return {
			props: {
				contractId,
				query
			}
		}
	}
}

export default Parceria
